import React from 'react'
import ConfirmFormChangesBeforeNavigate from 'support/pipelines/ConfirmFormChangesBeforeNavigate'
import ConfirmFormChangesBeforeSmartviewMount from 'support/pipelines/ConfirmFormChangesBeforeSmartviewMount'
import ConfirmFormChangesBeforeThemeChange from 'support/pipelines/ConfirmFormChangesBeforeThemeChange'
import { useForm } from '@morningtrain/react-resources'

export default function ConfirmFormChanges () {
  const form = useForm()

  React.useEffect(() => {
    if (form && typeof form.setAsChanged === 'function') {
      form.setAsChanged(false)
    }

    return () => {
      if (form && typeof form.setAsChanged === 'function') {
        form.setAsChanged(false)
      }
    }
  }, [form])

  return (
    <>
      <ConfirmFormChangesBeforeNavigate />
      <ConfirmFormChangesBeforeSmartviewMount />
      <ConfirmFormChangesBeforeThemeChange />
    </>
  )
}
